/**
 * Resolve the value a column's text filter matches against.
 *
 * Column options honored here:
 *   - filterValueMethod: (row) => value - match against a computed value
 *     instead of the raw accessor value
 *   - emptyFilterText: string - sentinel that matches rows whose value is
 *     empty (null, "", or 0), for columns that render such cells blank
 *
 * @param {Object} column - v6-style column definition
 * @param {Object} row - the original row data
 * @param {*} rawValue - the column's accessor value for this row
 */
export function getColumnFilterValue(column, row, rawValue) {
	const value = column?.filterValueMethod
		? column.filterValueMethod(row)
		: rawValue;

	if (
		column?.emptyFilterText &&
		(value == null || value === "" || value === 0)
	) {
		return column.emptyFilterText;
	}

	return value;
}
